var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("app-divider", { attrs: { label: "Cadastrante" } }),
      _c(
        "div",
        { staticClass: "pad5" },
        [
          _c("div", [
            _c("p", [
              _c("span", { staticClass: "label" }, [_vm._v("CPF/CNPJ:")]),
              _c("span", [
                _vm._v(
                  "  " + _vm._s(_vm.filterNull(_vm.cadastrante.pessoa.cpfCnpj))
                )
              ])
            ]),
            _c("p", [
              _c("span", { staticClass: "label" }, [
                _vm._v("Nome/Razão social:")
              ]),
              _c("span", [
                _vm._v(
                  "  " +
                    _vm._s(
                      _vm.filterNull(_vm.cadastrante.pessoa.nomeRazaoSocial)
                    )
                )
              ])
            ])
          ]),
          !_vm.isProcessoFisico
            ? _c("app-resumo-endereco", {
                attrs: { endereco: _vm.cadastrante.pessoa.endereco }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-614c2194", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-614c2194","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/resumo/AppResumoCadastrante.vue
// module id = null
// module chunks = 